import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here
import Config from "../../Config.jsx";

import Localization from "../../Localization.jsx"

import ContentDetailView from "./ContentDetailView.jsx"

import { Button, Modal, Group, Text } from '@mantine/core';
import { IconCategory } from '@tabler/icons-react';
import { BRAND_PRIMARY } from "../../theme/brandTheme.js";

class EditContentDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      open: false,
    };
    autoBind(this);
  }

  handleClose() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleUpdateClicked() {
    // todo: check empty content
    let contentDetailViewState = this.refs.contentDetailView.state;
    let contentDetailView = this.refs.contentDetailView;
    let return_message = contentDetailView.checkEmptyContent();
    console.log('return message:', return_message);
    console.log('content:', contentDetailViewState.contentText);
    console.log('payload:', contentDetailViewState.contentPayload);

    switch(return_message.flag){
      case ContentDetailView.TAG_OK:
        // save tag normally
        console.log('TAG_OK');
        let requestObj = {
          table: "component",
          where_field: "id",
          where_value: this.props.parent.getCurrentContent().id,
          row: {
            name: contentDetailViewState.contentName,
            diff: contentDetailViewState.contentDifficulty,
            content: contentDetailViewState.contentText,
            payload: this.refs.contentDetailView.serializePayload(),
            score_max: (typeof contentDetailViewState.scoreMaxUi === 'number' ? contentDetailViewState.scoreMaxUi : -1),
          }
        };
        this.props.root.refs.API.request("update", requestObj, this.updateContentOK, this.updateContentFail);
        this.handleClose();
        break;

      case ContentDetailView.TAG_WARNING:
        // prompt user
        let dialogText = {
          title: Localization.strings.EXIT,
          content: return_message.message,
          confirm: Localization.strings.YES,
        };
        this.props.root.refs.confirmDialog.show(dialogText, ()=>{
          let requestObj = {
            table: "component",
            where_field: "id",
            where_value: this.props.parent.getCurrentContent().id,
            row: {
              name: contentDetailViewState.contentName,
              diff: contentDetailViewState.contentDifficulty,
              content: contentDetailViewState.contentText,
              payload: this.refs.contentDetailView.serializePayload(),
              score_max: (typeof contentDetailViewState.scoreMaxUi === 'number' ? contentDetailViewState.scoreMaxUi : -1),
            }
          };
          this.props.root.refs.API.request("update", requestObj, this.updateContentOK, this.updateContentFail);
          this.handleClose();
        }, ()=>{});
        break;

      case ContentDetailView.TAG_ERROR:
        // block user from saving this problematic tag
        this.props.root.addNotification(return_message.message, false);
        break;
    }
  }

  updateContentOK(res) {
    this.props.parent.getContentByHotspotID(this.props.parent.props.currentHotspot['id']);
    this.props.root.addNotification(Localization.strings.UPDATED, true);

    var requestObj = {epack_id: this.props.root.getCurrentLocale().id};
    this.props.root.refs.API.request("touch_epack", requestObj);
  }

  updateContentFail(err) {
    console.log("update content fail " + err);
    this.props.root.addNotification(Localization.strings.UPDATE_FAILED, false);
  }

  handleCancelClicked() {
    this.handleClose();
  }

  render() {
    const currentContent = this.props.parent.getCurrentContent ? this.props.parent.getCurrentContent() : null;
    const contentViewKey = currentContent && currentContent.id != null ? `content-${currentContent.id}` : 'content-none';
    return (
      <div>
        <Modal
          opened={this.state.open}
          onClose={this.handleClose}
          size="xl"
          centered
          zIndex={2000}
          withCloseButton={false}
          padding={0}
          title={
            <Group gap={8} px="md" py="sm" style={{ width: '100%', backgroundColor: BRAND_PRIMARY, color: '#FFFFFF' }}>
              <IconCategory size={32} color="#FFFFFF" />
              <Text fw={600} c="#FFFFFF">
                {Config.GET_HOTSPOT_CONTENT_CONFIG(this.props.parent.getCurrentContent() != null? parseInt(this.props.parent.getCurrentContent().kind) : 0).title}
              </Text>
            </Group>
          }
          styles={{ header: { backgroundColor: BRAND_PRIMARY, padding: 0 }, title: { width: '100%' } }}
        >
          <div style={{ padding: '16px 24px' }}>
            <ContentDetailView key={contentViewKey} initialContent={currentContent} root={this.props.root} parent={this} ref="contentDetailView"/>
          </div>
          <Group justify="flex-end" mt="sm" p="md">
            <Button
              variant="subtle"
              onClick={this.handleCancelClicked}
            >
              {Localization.strings.CANCEL}
            </Button>
            <Button
              onClick={this.handleUpdateClicked}
            >
              {Localization.strings.UPDATE}
            </Button>
          </Group>
        </Modal>
      </div>
    )
  }
}

export default EditContentDialog;
